(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-article-premium"] && !Shopify.designMode) return;
  try {
    
(() => {
  const slugify = (value = '') => String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const init = (root) => {
    if (!root || root.dataset.awReady === 'true') return;
    const content = root.querySelector('[data-aw-article-content]');
    const toc = root.querySelector('[data-aw-article-toc]');
    const list = root.querySelector('[data-aw-article-toc-list]');
    const progress = document.querySelector('[data-aw-reading-progress]');
    const headings = content ? [...content.querySelectorAll('h2,h3')].filter((heading) => heading.textContent.trim()) : [];
    const links = [];
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      let uniqueId = id;
      let suffix = 2;
      while (usedIds.has(uniqueId) || document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading) {
        uniqueId = `${id}-${suffix}`;
        suffix += 1;
      }
      usedIds.add(uniqueId);
      heading.id = uniqueId;
      const item = document.createElement('li');
      item.className = heading.tagName === 'H3' ? 'is-h3' : 'is-h2';
      const link = document.createElement('a');
      link.href = `#${uniqueId}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list?.appendChild(item);
      links.push({ heading, link });
    });
    if (toc) toc.hidden = links.length < 2;

    if ('IntersectionObserver' in window && links.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((item) => item.link.removeAttribute('aria-current'));
          links.find((item) => item.heading === entry.target)?.link.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      links.forEach((item) => observer.observe(item.heading));
    }

    let progressStart = 0;
    let progressEnd = 0;
    let progressFrame = 0;

    const measureProgress = () => {
      if (!progress || !content) return;
      const rect = content.getBoundingClientRect();
      progressStart = rect.top + window.scrollY;
      progressEnd = progressStart + content.offsetHeight - window.innerHeight;
    };

    const updateProgress = () => {
      progressFrame = 0;
      if (!progress || !content) return;
      const value = progressEnd > progressStart
        ? Math.max(0, Math.min(1, (window.scrollY - progressStart) / (progressEnd - progressStart)))
        : 0;
      progress.style.width = `${value * 100}%`;
    };

    const requestProgressUpdate = () => {
      if (progressFrame) return;
      progressFrame = requestAnimationFrame(updateProgress);
    };

    const refreshProgress = () => {
      measureProgress();
      requestProgressUpdate();
    };

    document.addEventListener('scroll', requestProgressUpdate, { passive: true });
    window.addEventListener('resize', refreshProgress, { passive: true });
    refreshProgress();

    const copyButton = root.querySelector('[data-aw-copy-url]');
    copyButton?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyButton.textContent = root.dataset.copySuccess || copyButton.textContent;
      } catch (_) {}
    });

    const shareButton = root.querySelector('[data-aw-native-share]');
    if (!navigator.share) shareButton?.setAttribute('hidden', '');
    shareButton?.addEventListener('click', async () => {
      try {
        await navigator.share({ title: root.dataset.shareTitle || document.title, url: window.location.href });
      } catch (_) {}
    });
    root.dataset.awReady = 'true';
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-aw-article-premium]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-blog-premium"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = (value = '') => String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const inLetterRange = (letter, range) => { const value = normalize(letter).charAt(0); const limits = { 'a-f':['a','f'],'g-l':['g','l'],'m-r':['m','r'],'s-z':['s','z'] }; return limits[range] ? value >= limits[range][0] && value <= limits[range][1] : false; };
  const init = (root) => {
    if (!root || root.dataset.awReady === 'true') return;
    const cards = [...root.querySelectorAll('[data-aw-blog-card]')]; const search = root.querySelector('[data-aw-blog-search]'); const clear = root.querySelector('[data-aw-blog-clear]'); const count = root.querySelector('[data-aw-blog-count]'); const empty = root.querySelector('[data-aw-blog-empty]'); const filters = [...root.querySelectorAll('[data-aw-blog-filter]')]; let activeFilter = 'all';
    const render = () => { const query = normalize(search?.value || ''); let visible = 0; cards.forEach((card) => { const matchesSearch = !query || normalize(card.dataset.title).includes(query); const matchesFilter = activeFilter === 'all' || card.dataset.category === activeFilter || card.dataset.category === 'brand' && inLetterRange(card.dataset.letter, activeFilter); card.hidden = !(matchesSearch && matchesFilter); if (!card.hidden) visible += 1; }); if (count) count.textContent = `${visible} article${visible > 1 ? 's' : ''} affiché${visible > 1 ? 's' : ''}`; if (empty) empty.hidden = visible !== 0; if (clear) clear.hidden = !query; };
    filters.forEach((button) => button.addEventListener('click', () => { activeFilter = button.dataset.awBlogFilter || 'all'; filters.forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', selected ? 'true' : 'false'); }); render(); })); search?.addEventListener('input', render); clear?.addEventListener('click', () => { search.value = ''; search.focus(); render(); }); root.dataset.awReady = 'true'; render();
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-aw-blog-premium]').forEach(init); document.addEventListener('DOMContentLoaded', () => initAll()); document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aw-brand-catalog-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = (value = '') => String(value).trim().toLocaleLowerCase();
  const escapeQueryValue = (value = '') => String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const productPath = (handle = '') => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${root.endsWith('/') ? '' : '/'}products/${handle}`;
  };

  const createLink = (href, className, text) => {
    const link = document.createElement('a');
    link.href = href;
    link.className = className;
    if (text) link.textContent = text;
    return link;
  };

  const fetchStorefrontNewest = async ({ query, limit, exactVendors, fallbackCurrency }) => {
    const graphQuery = `query BrandProducts($first: Int!, $query: String!) {
      products(first: $first, query: $query, sortKey: CREATED_AT, reverse: true) {
        nodes {
          id
          title
          handle
          vendor
          availableForSale
          featuredImage { url altText }
          priceRange { minVariantPrice { amount currencyCode } }
        }
      }
    }`;
    const response = await fetch(`${window.location.origin}/api/2026-07/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: graphQuery, variables: { first: limit, query } })
    });
    if (!response.ok) throw new Error(`Storefront HTTP ${response.status}`);
    const payload = await response.json();
    if (payload?.errors?.length || !Array.isArray(payload?.data?.products?.nodes)) throw new Error('Storefront GraphQL');
    return payload.data.products.nodes
      .filter((product) => exactVendors.has(normalize(product.vendor)))
      .slice(0, limit)
      .map((product) => ({
        title: product.title || '',
        vendor: product.vendor || '',
        available: Boolean(product.availableForSale),
        url: productPath(product.handle || ''),
        image: product.featuredImage?.url || '',
        alt: product.featuredImage?.altText || product.title || '',
        price: product.priceRange?.minVariantPrice?.amount || '',
        currency: product.priceRange?.minVariantPrice?.currencyCode || fallbackCurrency
      }));
  };

  const fetchPredictiveFallback = async ({ query, limit, exactVendors, fallbackCurrency }) => {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(limit));
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'vendor,title,variants.title');
    const base = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${base}search/suggest.json?${params.toString()}`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Predictive HTTP ${response.status}`);
    const payload = await response.json();
    return (payload?.resources?.results?.products || [])
      .filter((product) => exactVendors.has(normalize(product.vendor)))
      .slice(0, limit)
      .map((product) => ({
        title: product.title || '',
        vendor: product.vendor || '',
        available: Boolean(product.available),
        url: product.url || '',
        image: product.featured_image?.url || product.image || '',
        alt: product.featured_image?.alt || product.title || '',
        price: product.price || '',
        currency: fallbackCurrency
      }));
  };

  const render = (root, grid, products) => {
    const fragment = document.createDocumentFragment();
    const locale = document.documentElement.lang || 'fr-FR';
    products.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'aw-brand-catalog__card';
      card.setAttribute('role', 'listitem');

      const media = createLink(product.url, 'aw-brand-catalog__media');
      media.setAttribute('aria-label', product.title || 'Produit');
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.alt || product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'aw-brand-catalog__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.textContent = 'AW';
        media.appendChild(placeholder);
      }

      const body = document.createElement('div');
      body.className = 'aw-brand-catalog__body';
      const availability = document.createElement('p');
      availability.className = `aw-brand-catalog__availability${product.available ? '' : ' is-unavailable'}`;
      availability.textContent = product.available ? root.dataset.availableLabel : root.dataset.unavailableLabel;

      const title = document.createElement('h3');
      title.appendChild(createLink(product.url, '', product.title || 'Produit'));

      const price = document.createElement('p');
      price.className = 'aw-brand-catalog__price';
      const numericPrice = Number(product.price);
      try {
        price.textContent = Number.isFinite(numericPrice)
          ? new Intl.NumberFormat(locale, { style: 'currency', currency: product.currency || root.dataset.currency || 'EUR' }).format(numericPrice)
          : String(product.price || '');
      } catch (_) {
        price.textContent = String(product.price || '');
      }

      const cta = createLink(product.url, 'aw-brand-catalog__cta', root.dataset.ctaLabel || 'Voir le produit');
      body.append(availability, title, price, cta);
      card.append(media, body);
      fragment.appendChild(card);
    });
    grid.replaceChildren(fragment);
    root.hidden = false;
  };

  const init = async (root) => {
    if (!root || root.dataset.awReady === 'true') return;
    root.dataset.awReady = 'true';
    const aliasesNode = root.querySelector('[data-aw-brand-aliases]');
    const grid = root.querySelector('[data-aw-brand-products]');
    const heading = root.querySelector('[data-aw-brand-heading]');
    if (!aliasesNode || !grid) return;

    let aliases = [];
    try { aliases = JSON.parse(aliasesNode.textContent || '[]'); } catch (_) { return; }
    aliases = [...new Set((Array.isArray(aliases) ? aliases : []).map((item) => String(item).trim()).filter(Boolean))];
    if (!aliases.length) return;

    const limit = Math.max(1, Math.min(10, Number(root.dataset.limit || 8)));
    const exactVendors = new Set(aliases.map(normalize));
    const query = aliases.map((alias) => `vendor:"${escapeQueryValue(alias)}"`).join(' OR ');
    const fallbackCurrency = root.dataset.currency || window.Shopify?.currency?.active || 'EUR';
    let products = [];
    let source = 'storefront';

    try {
      products = await fetchStorefrontNewest({ query, limit, exactVendors, fallbackCurrency });
    } catch (_) {
      source = 'predictive';
      try {
        products = await fetchPredictiveFallback({ query, limit, exactVendors, fallbackCurrency });
      } catch (_) {
        return;
      }
    }

    if (!products.length) return;
    if (heading) {
      const prefix = source === 'storefront'
        ? (root.dataset.newestPrefix || 'Nouveautés')
        : (root.dataset.productsPrefix || 'Produits');
      heading.textContent = `${prefix} ${root.dataset.brandTitle || ''}`.trim();
    }
    root.dataset.awCatalogSource = source;
    render(root, grid, products);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-aw-brand-catalog]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function(){var root=document.querySelector('[data-aw-article]');if(!root)return;var content=root.querySelector('[data-aw-article-content]');var toc=root.querySelector('[data-aw-toc]');var list=root.querySelector('[data-aw-toc-list]');if(content&&toc&&list){var heads=content.querySelectorAll('h2,h3');if(heads.length){heads.forEach(function(h,i){if(!h.id)h.id='section-'+(i+1);var li=document.createElement('li');var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.appendChild(a);list.appendChild(li)});toc.hidden=false}}var bar=document.querySelector('.aw-reading-progress span');function update(){var doc=document.documentElement;var max=doc.scrollHeight-doc.clientHeight;var pct=max>0?(doc.scrollTop/max)*100:0;if(bar)bar.style.width=pct+'%'}document.addEventListener('scroll',update,{passive:true});update();var copy=root.querySelector('[data-aw-copy-url]');if(copy){copy.addEventListener('click',function(){navigator.clipboard.writeText(window.location.href).then(function(){copy.textContent='Lien copié'})})}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{const modal=document.querySelector('[data-quick-view]');if(!modal)return;const content=modal.querySelector('[data-quick-view-content]');let lastFocus=null;const money=(c)=>new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format((c||0)/100);const esc=(s='')=>String(s).replace(/[&<>'\"]/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','\"':'&quot;'}[m]));const close=()=>{modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.classList.remove('quick-view-open');lastFocus?.focus?.()};const open=()=>{modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');document.body.classList.add('quick-view-open');modal.querySelector('[data-quick-view-close]')?.focus()};document.querySelectorAll('.product-card').forEach(card=>{if(card.querySelector('.quick-view-trigger'))return;const link=card.querySelector('a[href*="/products/"]');if(!link)return;const button=document.createElement('button');button.type='button';button.className='quick-view-trigger';button.textContent='Aperçu rapide';button.dataset.quickViewUrl=link.href;const image=card.querySelector('.product-card__image')||card;image.style.position='relative';image.appendChild(button)});document.addEventListener('click',async e=>{const trigger=e.target.closest('[data-quick-view-url]');if(trigger){e.preventDefault();lastFocus=trigger;content.innerHTML='<div class="quick-view__loading">Chargement…</div>';open();try{const url=new URL(trigger.dataset.quickViewUrl,location.origin);const handle=url.pathname.split('/products/')[1]?.split('/')[0];const r=await fetch(`${window.Shopify?.routes?.root||'/'}products/${handle}.js`,{headers:{Accept:'application/json'}});if(!r.ok)throw new Error();const p=await r.json();const available=p.variants.filter(v=>v.available);const first=available[0]||p.variants[0];const hasRealVariants=!(p.variants.length===1&&String(p.variants[0].title).toLowerCase()==='default title');const options=p.variants.map(v=>`<option value="${v.id}" data-price="${v.price}" ${v.id===first.id?'selected':''} ${v.available?'':'disabled'}>${esc(v.title)}${v.available?'':' — Indisponible'}</option>`).join('');const variantField=hasRealVariants?`<label class="quick-view__label" for="QuickViewVariant">Variante</label><select id="QuickViewVariant" class="quick-view__select" name="id" data-quick-view-variant>${options}</select>`:`<input type="hidden" name="id" value="${first.id}">`;content.innerHTML=`<div class="quick-view__grid"><div class="quick-view__media">${p.featured_image?`<img src="${esc(p.featured_image)}&width=1200" alt="${esc(p.title)}">`:''}</div><div class="quick-view__info"><span class="quick-view__eyebrow">Aperçu produit</span><h2 class="quick-view__title" id="QuickViewTitle">${esc(p.title)}</h2><div class="quick-view__price" data-quick-view-price>${money(first.price)}</div><div class="quick-view__description">${p.description||''}</div><form action="${window.Shopify?.routes?.root||'/'}cart/add" method="post">${variantField}<input type="hidden" name="quantity" value="1"><div class="quick-view__actions"><button class="btn" type="submit" ${first.available?'':'disabled'}>Ajouter au panier</button><a class="quick-view__link" href="${esc(p.url)}">Voir la fiche complète</a></div></form></div></div>`}catch{content.innerHTML='<div class="quick-view__loading">Impossible de charger ce produit.</div>'}return}if(e.target.closest('[data-quick-view-close]'))close()});modal.addEventListener('change',e=>{const select=e.target.closest('[data-quick-view-variant]');if(!select)return;const option=select.selectedOptions[0];modal.querySelector('[data-quick-view-price]').textContent=money(Number(option.dataset.price||0))});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('is-open'))close()})});

  } catch(e) { console.error(e); }
})();
})();
